import React from "react";
import { Link } from "react-router-dom";
import { SUBMISSION_QUICK_LINKS } from "@/constants/formOptions";
import { track } from "@/lib/analytics";
import { scrollToFormTop } from "@/lib/scrollToForm";

function hashFromTo(to) {
  const i = String(to).indexOf("#");
  return i >= 0 ? String(to).slice(i + 1) : null;
}

function pathFromTo(to) {
  const i = String(to).indexOf("#");
  return i >= 0 ? String(to).slice(0, i) : String(to);
}

/**
 * Visitor-facing quick-access strip for the Connect With SoKno area.
 * Labels are navigation-only; form headings/titles remain unchanged.
 */
export default function SubmissionQuickAccess({ className = "" }) {
  return (
    <nav
      className={`submission-quick-access ${className}`.trim()}
      aria-label="Quick access to submission forms"
      data-testid="submission-quick-access"
    >
      <ul className="submission-quick-access__list">
        {SUBMISSION_QUICK_LINKS.map((item) => {
          const anchorId = hashFromTo(item.to);
          const pathname = pathFromTo(item.to);
          return (
            <li key={item.id}>
              <Link
                to={item.to}
                className="submission-quick-access__link"
                data-testid={`submission-quick-access-${item.id}`}
                onClick={() => {
                  track("cta_click", {
                    route: item.to,
                    cta_label: item.label,
                    source_category: "submission_quick_access",
                  });
                  if (anchorId) {
                    // Same-route re-entry and lazy mount: scroll after navigation settles.
                    window.setTimeout(() => {
                      scrollToFormTop(anchorId, {
                        behavior: "auto",
                        pathname,
                      });
                    }, 0);
                  }
                }}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
